import React, { useState } from 'react';
import Select from '@material-ui/core/Select';

import { getSortOrder } from '../../utils/SettingsRetriever';

import './ListMenu.scss';

export default (props) => {
    const options = props.sortOptions;

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(getCurrentSort(props.currentSort));

    function handleMenuItemClick(option) {
        props.setSort(option)
        setSelectedIndex(getCurrentSort(option));
        setAnchorEl(null);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function getCurrentSort(value) {
        let returnIndex = 0
        if (props.sortOptions) {
            props.sortOptions.forEach( (option, index) => {
                if (option.name === value){
                    returnIndex = index;
                }
            })
            return returnIndex;
        }
    }
    
    if (!props.sortOptions) return null;
    
    return (
        <Select 
            defaultValue={getSortOrder()}
            onChange={(e) => handleMenuItemClick(e.target.value)}
            className="listMenuSortby"
            native
            id="sortby-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
        >
            {
                options.map((option, index) => (
                    <option key={index} selected={index === selectedIndex} value={option.name}>
                        {option.name}
                    </option>
                ))
            }
        </Select>
    );
}
